import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import html2pdf from "html2pdf.js";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import MainLayout from "../../../../Layouts/Main";
import CardHero from "Components/CardHero";
import PieChart from "Components/PieChart";

import { useDispatch, useSelector } from "react-redux";
import { getAssessmentSubCategoryDetails_USER } from "../../../../Redux/Slices/User/userSlice";
import { useLocation } from "react-router-dom";
//svg
import BackArrow from "../../../../Assets/Svg/Auth/BackArrow.svg";

import PDFIcom from "../../../../Assets/Images/pdfImg.png";
import DocIcon from "../../../../Assets/Images/doc.png";
import ExcelIcon from "../../../../Assets/Images/xlsx.png";
// import kgLogoEvidence from "../../../../Assets/Images/kgLogoEvidence.png";
import firstPage from "../../../../Assets/Images/pdfFirstPage.jpg";
import "./styles.scss";
import Button from "Components/Button";
import { capitalizeFirstLetter } from "Services/Utils/commonServices";
import FooterColorLineData from "Services/data/footerColorLineData";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ImageModal from "Components/ImageModal";

function AssessmentDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { assessmentId, subCategoryId } = useParams();
  const dispatch = useDispatch();
  const contentRef = useRef();
  const [subCategoryDetails, setSubCategoryDetails] = useState({
    performance_results: [],
  });
  const [showLoader, setShowLoader] = useState(false);
  const isLoading = useSelector((state) => state.user.isLoading);
  const activetabState = location.state?.activetabState;

  const outlineButton = {
    width: "auto",
    height: "48px",
    backgroundColor: "white",
    border: "1.5px solid #1F2155",
    textAlign: "center",
    marginRight: "15px",
  };
  const outlineTitle = {
    color: "#1F2155",
    fontSize: "20px",
    fontWeight: "600",
  };
  const downloadTitle = {
    fontSize: "20px",
    fontWeight: "600",
  };
  const downloadButton = {
    width: "auto",
    height: "48px",
    backgroundColor: "#1F2155",
    border: "1.5px solid #1F2155",
    textAlign: "center",
  };

  useEffect(() => {
    dispatch(
      getAssessmentSubCategoryDetails_USER({
        reportId: assessmentId,
        subCategoryId: subCategoryId,
        callBack: setDetails,
      })
    );
  }, []);

  const setDetails = (data) => {
    setSubCategoryDetails(data.data);
    if (
      data.data?.performance_results &&
      data.data.performance_results.length > 0
    ) {
    } else {
    }
  };

  const handleBackClick = () => {
    navigate("/", { state: { activeComponent: `${activetabState}Reports` } });
  };

  return (
    <MainLayout>
      <div
        className="assessment-container"
        style={{ padding: "25px 25px 25px 25px", backgroundColor: "#fafafa" }}
      >
        <div className="assessment-container-main">
          <div className="d-flex align-items-center">
            <img
              src={BackArrow}
              alt="backarrow"
              width="25px"
              height="23px"
              onClick={handleBackClick}
              style={{
                marginLeft: "-10px",
                cursor: "pointer",
              }}
            />
            <h2 className="assessment-title ms-2">
              {isLoading === "loading" ? (
                <Skeleton width={200} /> // Show skeleton when loading
              ) : (
                capitalizeFirstLetter(
                  subCategoryDetails?.assessment_details?.assessment_name
                ) || ""
              )}
            </h2>
          </div>
          <div className="d-flex">
            {/* <Button
              title="Assessments Tracking"
              buttonStyle={outlineButton}
              titleStyle={outlineTitle}
              onClick={() =>
                navigate(
                  "/pre-assessment/" +
                    assessmentId +
                    "/" +
                    subCategoryId +
                    "/assessment-journey",
                  {
                    state: {
                      assessmentName:
                        subCategoryDetails?.assessment_details?.assessment_name,
                    },
                  }
                )
              }
            /> */}
          </div>
        </div>
        <div ref={contentRef}>
          <div className="card-hero-container">
            {isLoading === "loading" ? (
              <Skeleton count={1} height={200} />
            ) : (
              <CardHero
                headingName={
                  subCategoryDetails.performance_results[0]?.category_name ||
                  "N/A"
                }
                details={
                  "This score is based on the assessment you have attended"
                }
                rating={subCategoryDetails.performance_results[0]?.average_score
                  ? Number(subCategoryDetails.performance_results[0].average_score).toFixed(0)
                  : "N/A"
                }
              />
            )}</div>

          {/* Performance Results Skeleton */}
          <div className="scores-container my-4">
            {isLoading === "loading" ? (
              <>
                <Skeleton count={1} height={200} />
                <Skeleton count={1} height={200} />
                <Skeleton count={1} height={200} />
              </>
            ) : (
              subCategoryDetails.performance_results[0]?.sub_categories.map(
                (item, index) => {
                  const performanceRating = !isNaN(Number(item.average_score))
                    ? Number(item.average_score).toFixed(0)
                    : "N/A";

                  const color = performanceRating !== "N/A" && Number(performanceRating) < 50
                    ? "#ff352e"  // Red if less than 50
                    : "#02cf35"; // Green otherwise

                  return (
                    <div key={index} className="score-item">
                      <PieChart
                        headingName={item.subCategory_name}
                        performanceRating={
                          !isNaN(Number(item.average_score))
                            ? Number(item.average_score).toFixed(0)
                            : "N/A"
                        }
                        color={color}
                      />
                    </div>
                  );
                }
              )
            )}
          </div>

          <div className="user-insights-container">
            <h2>Insight</h2>
            <div className="insight-content">
              {isLoading === 'loading' ? (
                <Skeleton count={4} height={28} style={{ marginBottom: "10px" }} />
              ) : subCategoryDetails.researchData?.length > 0 ? (
                subCategoryDetails.researchData.map((item, index) =>
                  item.insights ? (
                    <div
                      key={index}
                      className="insight-item allText"
                      dangerouslySetInnerHTML={{ __html: item.insights }}
                    />
                  ) : null
                )
              ) : (
                <p>No insights available.</p>
              )}
            </div>
          </div>


          <div className="evidence-container my-4">
            <div className="evidence-heading">
              <div className="evidence-heading-details">
                <h2>Assessment References</h2>
                <h5>Captured images from your company</h5>
              </div>
              {/* <div>
                <img src={kgLogoEvidence} alt="logo" />
              </div> */}
            </div>
            <div className="evidence-grid">
              {isLoading === "loading" ? (
                <Skeleton count={4} height={120} />
              ) : subCategoryDetails.researchData?.length > 0 ? (
                subCategoryDetails.researchData.map((item, index) => (
                  <div key={index} className="evidence-item-box">
                    {(item.upload || []).map((uploadItem, uIndex) => {
                      const images = Array.isArray(uploadItem.image_url)
                        ? uploadItem.image_url.filter((url) =>
                          /\.(jpg|jpeg|png|gif)$/i.test(url)
                        )
                        : [];

                      return (
                        <div key={uIndex} className="evidence-upload-box">
                          {images.length > 0 && (
                            <div className="evidence-images">
                              {images.map((url, imgIndex) => (
                                <ImageModal
                                  key={imgIndex}
                                  src={url}
                                  alt={`evidence-${index}-${uIndex}-${imgIndex}`}
                                  className="evidence-img"
                                />
                              ))}
                            </div>
                          )}

                          {uploadItem.text && (
                            <div
                              className="evidence-text allText"
                              dangerouslySetInnerHTML={{ __html: uploadItem.text }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                ))
              ) : (
                <p>-</p>
              )}
            </div>




            <div className="evidence-pdf">
              <div className="evidence-pdf-details">
                <h4 style={{ color: "black", fontWeight: "700" }}>Documents</h4>
                <h6 style={{ fontWeight: "600" }}>
                  All formats of important documents from your company
                </h6>
                <div className="evidence-pdf-container">
                  {isLoading === "loading" ? (
                    <Skeleton count={3} height={40} />
                  ) : subCategoryDetails.researchData?.length > 0 ? (
                    subCategoryDetails.researchData.flatMap((item, index) =>
                      (item.upload || []).flatMap((uploadItem, uIndex) => {
                        const urls = Array.isArray(uploadItem.image_url)
                          ? uploadItem.image_url
                          : [];

                        return urls
                          .filter((url) => /\.(pdf|docx|doc|xls|xlsx)$/i.test(url))
                          .map((url, urlIndex) => {
                            const isPDF = /\.pdf$/i.test(url);
                            const isDoc = /\.(docx|doc)$/i.test(url);
                            const isExcel = /\.(xlsx|xls)$/i.test(url);

                            return (
                              <div
                                key={`${index}-${uIndex}-${urlIndex}`}
                                className="individual-pdf-container"
                              >
                                <a href={url} target="_blank" rel="noopener noreferrer">
                                  {isPDF && <img src={PDFIcom} alt="PDF" width="75px" />}
                                  {isDoc && <img src={DocIcon} alt="DOC" width="75px" />}
                                  {isExcel && <img src={ExcelIcon} alt="Excel" width="75px" />}
                                  <p>
                                    {isPDF
                                      ? "Open PDF"
                                      : isDoc
                                        ? "Open DOC"
                                        : isExcel
                                          ? "Open Excel"
                                          : ""}
                                  </p>
                                </a>
                              </div>
                            );
                          });
                      })
                    )
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
            </div>

          </div>

          <div className="user-insights-container">
            <h2>Recommendations</h2>

            {isLoading === "loading" ? (
              <Skeleton count={3} height={28} />
            ) : subCategoryDetails.recommendations?.length > 0 ? (
              <div className="recommendations-list">
                {subCategoryDetails.recommendations.map((rec, index) => (
                  <div key={index} className="recommendation-item-box">
                    {rec.message && (
                      <div
                        className="recommendation-message allText"
                        dangerouslySetInnerHTML={{ __html: rec.message }}
                      />
                    )}

                    {/* Loop through image_url array */}
                    <div className="recommendation-images">
                      {Array.isArray(rec.image_url) &&
                        rec.image_url.map((url, fileIndex) => {
                          const isImage = /\.(jpg|jpeg|png|gif)$/i.test(url);
                          const isPDF = /\.pdf$/i.test(url);
                          const isDoc = /\.(docx|doc)$/i.test(url);
                          const isExcel = /\.(xlsx|xls)$/i.test(url);

                          if (isImage) {
                            return (
                              <ImageModal
                                key={fileIndex}
                                src={url}
                                alt={`recommendation-${index}-${fileIndex}`}
                                className="recommendation-img"
                              />
                            );
                          } else if (isPDF || isDoc || isExcel) {
                            return (
                              <div key={fileIndex} className="individual-doc-container">
                                <a href={url} target="_blank" rel="noopener noreferrer">
                                  {isPDF && <img src={PDFIcom} alt="PDF" width="75px" />}
                                  {isDoc && <img src={DocIcon} alt="DOC" width="75px" />}
                                  {isExcel && <img src={ExcelIcon} alt="Excel" width="75px" />}
                                  <p>
                                    {isPDF
                                      ? "Open PDF"
                                      : isDoc
                                        ? "Open DOC"
                                        : isExcel
                                          ? "Open Excel"
                                          : ""}
                                  </p>
                                </a>
                              </div>
                            );
                          } else return null;
                        })}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No recommendations available.</p>
            )}
          </div>




        </div>
      </div>
    </MainLayout>
  );
}

export default AssessmentDetails;
